import { Icon, IconProps } from "@chakra-ui/react";

export function AddCircleIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 32 32" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 3.33301C22.9956 3.33301 28.667 9.00439 28.667 16C28.667 22.9956 22.9956 28.667 16 28.667C9.00439 28.667 3.33301 22.9956 3.33301 16C3.33301 9.00439 9.00439 3.33301 16 3.33301ZM16 4.66699C9.74077 4.66699 4.66699 9.74077 4.66699 16C4.66699 22.2592 9.74077 27.333 16 27.333C22.2592 27.333 27.333 22.2592 27.333 16C27.333 9.74077 22.2592 4.66699 16 4.66699Z"
        fill="currentColor"
      />
    </Icon>
  );
}
